/**
 * Bottom Sheet — drag gesture, snap points (half 50vh, full 90vh, closed)
 */
(function () {
  var sheet = document.querySelector('.bsheet');
  var overlay = document.getElementById('BSheet-Overlay');
  if (!sheet || !overlay) return;

  var header = sheet.querySelector('.bsheet__header');
  var content = sheet.querySelector('.bsheet__content');
  var closeBtn = document.getElementById('BSheet-Close');
  var applyBtn = sheet.querySelector('.bsheet__apply');
  var clearBtn = sheet.querySelector('.bsheet__clear');

  var SNAP_CLOSED = 0;
  var SNAP_HALF = 1;
  var SNAP_FULL = 2;

  var state = SNAP_CLOSED;
  var startY = 0;
  var startTranslate = 0;
  var currentTranslate = 0;
  var isDragging = false;
  var scrollTop = 0;

  function vh(pct) {
    return window.innerHeight * pct / 100;
  }

  function getTranslateForSnap(snap) {
    if (snap === SNAP_FULL) return window.innerHeight - vh(90);
    if (snap === SNAP_HALF) return window.innerHeight - vh(50);
    return window.innerHeight;
  }

  function setTranslate(y) {
    sheet.style.transform = 'translateY(' + y + 'px)';
  }

  function snapTo(snap, animate) {
    state = snap;
    sheet.classList.remove('is-dragging');

    if (animate !== false) {
      sheet.style.transition = 'transform 0.35s cubic-bezier(0.32, 0.72, 0, 1)';
    }

    if (snap === SNAP_CLOSED) {
      setTranslate(window.innerHeight);
      overlay.classList.remove('is-visible');
      document.body.classList.remove('bsheet-open');
      sheet.classList.remove('is-half', 'is-full');
    } else if (snap === SNAP_HALF) {
      setTranslate(getTranslateForSnap(SNAP_HALF));
      overlay.classList.add('is-visible');
      document.body.classList.add('bsheet-open');
      sheet.classList.add('is-half');
      sheet.classList.remove('is-full');
    } else {
      setTranslate(getTranslateForSnap(SNAP_FULL));
      overlay.classList.add('is-visible');
      document.body.classList.add('bsheet-open');
      sheet.classList.remove('is-half');
      sheet.classList.add('is-full');
    }
  }

  function open() {
    snapTo(SNAP_HALF);
  }

  function close() {
    if (window.innerWidth <= 767) {
      snapTo(SNAP_CLOSED);
    } else {
      sheet.classList.remove('active');
      document.body.classList.remove('open-cc');
    }
  }

  // Drag handling
  function onTouchStart(e) {
    if (content.contains(e.target) && content.scrollTop > 0) return;

    isDragging = true;
    startY = e.touches[0].clientY;
    startTranslate = getTranslateForSnap(state);
    currentTranslate = startTranslate;
    sheet.classList.add('is-dragging');
    sheet.style.transition = 'none';
  }

  function onTouchMove(e) {
    if (!isDragging) return;

    var touchY = e.touches[0].clientY;
    var delta = touchY - startY;
    var newY = startTranslate + delta;

    var minY = getTranslateForSnap(SNAP_FULL);
    if (newY < minY) newY = minY;
    if (newY > window.innerHeight) newY = window.innerHeight;

    currentTranslate = newY;
    setTranslate(newY);

    var overlayProgress = 1 - (newY / window.innerHeight);
    if (overlayProgress < 0) overlayProgress = 0;
    if (overlayProgress > 1) overlayProgress = 1;
    overlay.style.opacity = overlayProgress;
  }

  function onTouchEnd() {
    if (!isDragging) return;
    isDragging = false;
    sheet.classList.remove('is-dragging');
    overlay.style.opacity = '';

    var velocity = currentTranslate - startTranslate;
    var halfY = getTranslateForSnap(SNAP_HALF);
    var fullY = getTranslateForSnap(SNAP_FULL);

    if (velocity > 80) {
      if (state === SNAP_FULL) {
        snapTo(SNAP_HALF);
      } else {
        snapTo(SNAP_CLOSED);
      }
    } else if (velocity < -80) {
      if (state === SNAP_HALF) {
        snapTo(SNAP_FULL);
      } else {
        snapTo(SNAP_HALF);
      }
    } else {
      var distClosed = Math.abs(currentTranslate - window.innerHeight);
      var distHalf = Math.abs(currentTranslate - halfY);
      var distFull = Math.abs(currentTranslate - fullY);

      var minDist = Math.min(distClosed, distHalf, distFull);
      if (minDist === distFull) {
        snapTo(SNAP_FULL);
      } else if (minDist === distHalf) {
        snapTo(SNAP_HALF);
      } else {
        snapTo(SNAP_CLOSED);
      }
    }
  }

  if (header) {
    header.addEventListener('touchstart', onTouchStart, { passive: true });
    header.addEventListener('touchmove', onTouchMove, { passive: false });
    header.addEventListener('touchend', onTouchEnd);
  }

  // Close triggers
  if (closeBtn) {
    closeBtn.addEventListener('click', close);
  }

  if (overlay) {
    overlay.addEventListener('click', close);
  }

  if (applyBtn) {
    applyBtn.addEventListener('click', close);
  }

  // Expose globally
  window.BSheet = {
    open: open,
    close: close,
    snapTo: snapTo,
    SNAP_CLOSED: SNAP_CLOSED,
    SNAP_HALF: SNAP_HALF,
    SNAP_FULL: SNAP_FULL
  };
})();
